import { FormType } from './form';

export const ParentObjTypes = [
  FormType.SERVICE,
  FormType.PROJECT,
  FormType.SIMPLETASK,
  FormType.SOURCELIST,
  FormType.PRODUCTION,
];
export const ActiveColumnEnabledTypes = [FormType.ITEM];

export const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.bmp', '.svg'];
export const previewExtensions = [...imageExtensions, '.pdf'];
